import { useState } from 'react';
import { PlaylistAssignPanel } from './PlaylistAssignPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AssignPlaylistModalTrigger = ({
  playlistId,
  portalId,
  assignmentIds,
  renderTrigger
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderTrigger({
      openModal,
      isOpen
    }), isOpen && /*#__PURE__*/_jsx(PlaylistAssignPanel, {
      assignmentIds: assignmentIds || [],
      onClose: closeModal,
      onSuccess: closeModal,
      playlistId: playlistId,
      portalId: portalId
    })]
  });
};